/**
 * 真人出镜专属页(SEEDANCE 真人出镜 P0.5,0915 车 F;P0.6 单页化重排)。
 *
 * ═══ 为什么另起一页,不复用通用创建页 ═══════════════════════════════════════════
 * 0914 批已经把 cast=real 接进了通用创建页(`VideoCreatePage`,D2~D4)——那条路径
 * **保留作编排底座**(真人两道闸/三态可视化/verification 状态机都长在那边,幕二分镜、
 * 素材库、拍法选择器等复杂功能都靠它),但对"选个人、写句话/传段参考视频就出片"这个
 * 最常见的真人出镜诉求来说太重了。0915 凌晨老板拍板追加专属页方案,初版**无模型选择**
 * (真人线只有 seedance2.0),引导简单直白;同日稍晚二次拍板放开档位 —— vapeur 真单探针
 * 验过全系模型(2.0/2.5/fast/mini)图/视频参考全通,不该再锁死一个借位常量当报价占位
 * (见 `../model/realPersonModelTiers.ts`:内部模型 id / 计费 model_code / 时长-分辨率能力表
 * 单点收口,页面只管渲染 + 联动钳位)。
 *
 * ═══ 单页三区块(P0.6 0915 老板拍板:「分步太多,所有选项融进一个页面」)═══════════
 * 初版是"两步 + 折叠区"(StepIndicator + step 状态),同日老板反馈后单页化:
 *   ① 谁来出镜:真人人物横向小卡行,点选即选中(不再"进下一步"),复用 D3/D4 那套
 *      两把尺判据(`realPersonPickState`,entities 层导出,与通用创建页/分身舱同一份,
 *      不 second-guess);**换出镜人不清空已填内容**(拍板点 D)。
 *   ② 想怎么拍:「文案出片 / 换我出镜」二选一分段 + 随切内容区。**形制对齐自由创作页**
 *      (0915 拍板「参考自由创作,差距不要太大」):时长+画幅置顶 → 「想拍什么」260px
 *      大框 + 直发副标题 + 字数计数,主体区 border-primary/40 强调框。
 *   ③ 声音与配乐:桌面(xl+)右侧栏常驻(拍板点 A,不再折叠),窄屏落回主列末尾。
 *   底部 sticky 条:实时摘要句 + 「还差什么」缺口提示(拍板点 B)+ 积分预估 + 出片。
 *   步骤条取消,只留 1/2/3 小眉标做阅读顺序引导,无导航语义(拍板点 C)。
 *   容器 w-full 铺满(与通用创建页 0810 满屏批同口径;初版误用 max-w-4xl 已修)。
 *
 * ═══ 第 3 步契约(0915 车 F 契约钉死批,G5 已修三面断链)═══════════════════════
 * 直发单镜(本页两种玩法都不经编排)此前**没有开关**能表达"这次要不要配音/字幕/BGM"——
 * `voiceovers`/`subtitleFontScale`/`bgmId` 过去只在编排后(幕二)由 ai 预填才被消费
 * (`VideoIntakeDeck.tsx` 原话「不编排直发则只出画面、无配音字幕」)。G5 批修完断链后
 * createTask 直发路径认三个新开关了,字段名与 `VideoComposeOptions`(成片重合成选项)
 * **逐字同名**:`voiceEnabled` 配 `voiceovers`/`speechModes`(逐镜数组取长度 1 当单镜用)、
 * `subtitleEnabled` 配 `subtitleFontScale`、`bgmEnabled` 配 `bgmId`/`customBgmObjectKey`。
 * ★音色接线终版(0915 P0.6,任务书车 V,债已还清):选择器曾是纯预置音色列表
 *   (`voiceTone`,CosyVoice 预置音色 id),没带声纹的出镜人默认取一个中性普通话档 ——
 *   出镜人自己的克隆声纹(`character.voiceProfileId`)那批正式接进视频线,但只暴露了
 *   「本人声音」一个占位档,看不出绑的是哪条声纹、换不了别的声纹、没有方言/语言/演绎/
 *   语速/试听(现网真实事故:人物「阿杰」绑的声纹 label 叫「彭姐」、实测 F0 207.8Hz 是
 *   女声——页面上完全看不出绑的是哪条,静默错配)。
 *
 * ═══ 声音区对齐数字人(P0.6 0915 车 I,本批)═══════════════════════════════════
 * 换成数字人页(`DigitalHumanCreatePage`)那套声音 V2 四件套 + 试听,共享层直接复用
 * (entities/dh-profile:`voiceV2Options.ts` 词表 + `dhProfileService.listVoiceProfiles`
 * 声纹库 query;试听端点 `videoService.previewVoice` 镜像声明数字人页
 * `digitalHumanService.previewVoice` 的请求/响应形状,同打 `/digital-human/voices/preview`
 * ——不 import digitalHumanService,features 互不 import 是本仓 ESLint 硬闸):
 *   ① 声纹选择:列出该租户可用声纹(不再只有绑定那一条),每条显示真实声纹名;
 *      人物自带的那条(`character.voiceProfileId`)默认选中并标注「人物绑定」。
 *   ② 预置音色:保留原样(`VOICE_OPTIONS`,CosyVoice 旧引擎)。
 *   ③ 语言/方言/演绎:**仅克隆声纹(qwen)生效**,预置音色是旧引擎不认这三个参数——
 *      选中预置音色时收起(禁用置灰 + 顶部说明),抄数字人页的处理方式;带了也被后端
 *      静默忽略(0915 演示机实证:presetVoice+方言=sichuan 仍返 200,方言没生效)。
 *      方言依附语言:仅中文可非空,换语言顺手清空方言(`onChangeVoiceLanguage`)。
 *   ④ 语速:复用既有字段 `voiceSpeechRate`(视频线老字段,绝不可改名,合法域
 *      0.9~1.3——与数字人页 `speechRate` 字段名不同、合法域也不同,两条线各自的量,
 *      两条路都吃这个字段,不因预置音色而收起)离散档,不做连续滑杆(0908 老板实测
 *      「设 1.2 没变快」的教训)。
 *   ⑤ 试听:调 `videoService.previewVoice`,按当前组合(声纹/预置 × 语言 × 方言 ×
 *      演绎 × 语速)现合成一小段;试听端点吃 `speechRate`(与提交任务的
 *      `voiceSpeechRate` 是**同一个量两个名字**,两个上下文故意不统一)。
 * ★错配防呆:选中声纹与人物绑定声纹不是同一条时给一句轻提示(不拦)。
 *
 * 「保留参考视频原声」(换我出镜专属,`keepSourceAudio`)P0.6 同批接进契约:ai 成片合成
 * 阶段把参考视频自身的原声/环境音混进成片,开关已放开(`KEEP_SOURCE_AUDIO_READY=true`)。
 * 「补充说明」语义是场景/多人指定,不是口播文案——拼进 `userInput`(换行接在默认模板后),
 * 不进 `voiceovers`。
 */
import { useMemo, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useCompliance } from "@/contexts/AuthContext";
import { useQuery } from "@tanstack/react-query";
import { ArrowRight, Loader2, Play, Sparkles, UserRound } from "lucide-react";

import { Badge } from "@/shared/ui/badge";
import { Button } from "@/shared/ui/button";
import { Card, CardContent } from "@/shared/ui/card";
import { Label } from "@/shared/ui/label";
import { PageHeader } from "@/shared/ui/PageHeader";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/shared/ui/select";
import { Switch } from "@/shared/ui/switch";
import { Textarea } from "@/shared/ui/textarea";
import { toast } from "@/shared/hooks/use-toast";
import { cn } from "@/shared/lib/utils";
import { clickableCardProps, CARD_WALL_RADIUS } from "@/shared/ui/cardWall";
import { pauseOtherAudio } from "@/shared/lib/exclusiveAudio";
import { VIDEO_DEFAULT_RESOLUTION } from "@/entities/scene-card/model/creditRates";
import { SKU } from "@/entities/pricing/model/priceBook";
import { usePriceBook } from "@/entities/pricing/model/usePriceBook";
import { acquireQuoteId, useQuotePreview } from "@/entities/pricing/model/useQuote";
import {
  characterService,
  realPersonEligibleOf,
  type CharacterDto,
} from "@/entities/character/api/characterService";
import {
  realPersonPickState,
  realPersonPickReason,
  resolveCharacterPick,
  type CharacterPick,
} from "@/entities/character/ui/CharacterPickerDialog";
import { CharacterThumb } from "@/entities/character/ui/CharacterThumb";
// ★声音 V2 共享层(0908 契约,四车同稿):声纹库 query/service + 方言/语言/演绎词表。
// entities 层允许被任意 feature import(FSD 边界只禁 features 互相 import),这不是
// 「引数字人 feature 的代码」——dh-profile 是它专属的领域下沉层,video 与 digital-human
// 两个 feature 各自 import 同一份 entities,互不知道对方存在。
import {
  dhProfileService,
  voiceProfileSupportsTuning,
  type VoiceProfileDto,
} from "@/entities/dh-profile/api/dhProfileService";
import { LegacyVoiceBadge } from "@/entities/dh-profile/ui/LegacyVoiceBadge";
import {
  LEGACY_PROFILE_LOCK_TEXT,
  PRESET_VOICE_LOCK_TEXT,
  VOICE_STYLE_TRADEOFF_TEXT,
  DH_DEFAULT_VOICE_LANGUAGE,
  DH_DEFAULT_VOICE_STYLE,
  DH_VOICE_DIALECTS,
  DH_VOICE_LANGUAGES,
  DH_VOICE_STYLES,
  dialectLabelOf,
  voiceStyleLabelOf,
} from "@/entities/dh-profile/model/voiceV2Options";
import { applyCharacterPick, withCharacterSheet } from "../model/characterPick";
import { buildTaskRequest } from "../model/buildTaskRequest";
import type { FormState } from "../model/videoCreateTypes";
import {
  videoService,
  type VideoBgmDto,
  type VideoEntity,
  type VideoResolution,
  type VideoTaskCreateRequest,
} from "../api/videoService";
import {
  DEFAULT_IDENTITY_REF_MODE,
  defaultIdentityRefMode,
  identityRefBillsAsVideoInput,
  identityRefOptions,
  type IdentityRefMode,
} from "../model/identityRefMode";
import {
  DEFAULT_REAL_PERSON_MODEL,
  REAL_PERSON_DEFAULT_DURATION_SEC,
  REAL_PERSON_MODEL_TIERS,
  clampDurationForModel,
  clampResolutionForModel,
  realPersonModelTier,
  realPersonQuoteMetrics,
  type RealPersonModelId,
} from "../model/realPersonModelTiers";
import {
  SWAP_LONG_TIER_MODEL,
  assessSwapDuration,
  swapPayloadDurationSec,
  swapVerdictBlocksSubmit,
} from "../model/realPersonSwapTier";
import { templateWantsProduct, unfilledSlots } from "../model/realPersonIntake";
import {
  DEFAULT_REAL_PERSON_SPEECH_MODE,
  REAL_PERSON_SPEECH_MODE_OPTIONS,
  realPersonSpeechModes,
  type RealPersonSpeechMode,
} from "../model/realPersonSpeechMode";
import { realPersonSubmitErrorText } from "../model/realPersonErrors";
import { VideoBgmPanel } from "./components/VideoBgmPanel";
import {
  RealPersonAdvancedPlay,
  type RealPersonMode,
} from "./components/realperson/RealPersonAdvancedPlay";
import { RealPersonProductPanel } from "./components/realperson/RealPersonProductPanel";
import { RealPersonSampleWall } from "./components/realperson/RealPersonSampleWall";
import {
  RealPersonExplosiveStrip,
  RealPersonTemplateStrip,
} from "./components/realperson/RealPersonSourceStrip";
import { RealPersonSwapPanel } from "./components/realperson/RealPersonSwapPanel";
import { RealScriptButton, RealScriptStatus } from "./components/realperson/RealScriptControls";
import { useRealPersonBrief } from "./components/realperson/useRealPersonBrief";
import { useSwapReference } from "./components/realperson/useSwapReference";
import { OptionChip, OptionChipGroup } from "./components/OptionChip";
import { VOICE_OPTIONS } from "@/shared/lib/video/labels";
import { VoiceoverCapHint, VoiceoverCutSubmitNotice } from "@/shared/ui/VoiceoverCapHint";
import { errorToast, errorText } from "@/shared/lib/apiErrors";

/** provider 字段维持 "seedance" 不变(契约逐字)—— 模型档的差异全在 `model` 字段里。 */
const REAL_PERSON_PROVIDER = "seedance" as const;

/**
 * 分辨率档(0915 二次拍板放开):480p/720p/1080p 全展示,1080p 是否可选由所选模型档定
 * (fast/mini 无 1080p,见 `realPersonModelTiers.ts`)。默认 720p 与通用创建页同口径。
 */
const RESOLUTION_OPTIONS: readonly { label: string; value: VideoResolution }[] = [
  { label: "480p", value: "480p" },
  { label: "720p", value: "720p" },
  { label: "1080p", value: "1080p" },
] as const;

/**
 * 文案出片时长档 —— ★不用通用创建页的「短15/中30/长45」三档字面:那三档走的是
 * `briefTargetSec` + `bareSendDurationSec` 钳位链,而**本页没有能力表接口**(不拉
 * `/capabilities`,时长上限改由 `realPersonModelTiers.ts` 的静态档位表给)——不这样做的话
 * 钳位上限会静默回落 `BARE_SEND_FALLBACK_MAX_SEC=15`,选「中·30s」会被钳成 15s 却不说明
 * (bug 9/E-14a 同款陷阱)。这里直接给「选了就是这个数」的档位,不做会撒谎的承诺。
 *
 * ★2.5 独有 20s/30s(它是唯一 maxDurationSec=30 的档,见 realPersonModelTiers.ts)——
 * 其余三档只有基础三档,选中值超出新档上限时由 `onPickModel` 下钳并 toast。
 */
const TEXT_DURATION_OPTIONS_BASE = [
  { label: "5s", value: 5 },
  { label: "10s", value: 10 },
  { label: "15s", value: 15 },
] as const;
const TEXT_DURATION_OPTIONS_LONG = [
  { label: "20s", value: 20 },
  { label: "30s", value: 30 },
] as const;

function textDurationOptions(
  model: RealPersonModelId
): readonly { label: string; value: number }[] {
  return model === "vapeur-seedance-2-5"
    ? [...TEXT_DURATION_OPTIONS_BASE, ...TEXT_DURATION_OPTIONS_LONG]
    : TEXT_DURATION_OPTIONS_BASE;
}

/**
 * 画幅档(0915 老板问「是不是比例少了」核对):seedance-2.0 能力表全集是
 * 16:9/9:16/1:1/4:3/3:4/21:9/adaptive(ai capabilities.py 同源;vapeur 是中转,同一模型
 * 同一能力集)——此前只放了 2 档,确实少了,补齐 6 档。adaptive 不放:它按参考图实测
 * 定比例,文案出片没有参考图,放出来是个没意义的选项。
 */
const RATIO_OPTIONS = [
  { label: "9:16 竖屏", value: "9:16" },
  { label: "16:9 横屏", value: "16:9" },
  { label: "1:1 方形", value: "1:1" },
  { label: "3:4 竖幅", value: "3:4" },
  { label: "4:3 横幅", value: "4:3" },
  { label: "21:9 宽幅", value: "21:9" },
] as const;

/** 换我出镜:ratio 字段必填但服务端按参考视频的实际画幅走,这里只是占位值。 */
const SWAP_RATIO_PLACEHOLDER = "9:16";

/* 换我出镜 4 秒下限(VID-101)随参考视频体检一起搬到 `components/realperson/useSwapReference.ts`。 */

/**
 * 第 3 步口播音色的默认档(0915 音色接线终版):选择器是纯预置音色列表,不绑出镜人 ——
 * 「沉稳权威」是 `VOICE_OPTIONS` 里语气最接近"中性普通话"的一档,不含方言/情绪色彩。
 */
const NEUTRAL_VOICE_TONE = "longxiaoxia_v3";

/**
 * 语速离散档(P0.6 0915 车 I,复用数字人页的口径:0908 老板实测「设了 1.2 倍实际没快」=
 * 连续滑杆拖不准,改离散档点得准)。★值域跟数字人页**不同**——这里提交的是
 * `voiceSpeechRate`(视频线老字段,合法域 0.9~1.3),不是数字人页的 `speechRate`
 * (合法域 0.5~2.0);照抄数字人页的那组值(0.9/1.0/1.2/1.5)会把 1.5 发到域外,
 * 档位必须按本线合法域重新定,顶格给到 1.3。
 *
 * ★默认档钉死 1.1,不是"正常"直觉的 1.0(主session 回炉一刀,0915 取证):改这批之前
 * 真人页**根本不发** `voiceSpeechRate` 这个字段,ai 侧兜底是 1.1(`app/modules/video/
 * api/routes.py`:`voiceSpeechRate: float = 1.1` 以及取值处 `float(result.get(
 * "voiceSpeechRate") or 1.1)`;`video/infrastructure/tts.py` cosyvoice 路自己的常量
 * `_SPEECH_RATE=1.18` 头注也写着「营销口播要有激情/节奏感,1.1 偏温了」——两处都不是
 * 1.0)。**给一个此前不发的字段加控件时,默认值必须等于后端原兜底值**,否则就是拿
 * 新 UI 静默把存量出片速度改慢 10%,老板会直接感觉"怎么变慢了"却找不到原因(第一版
 * 曾把默认写成 1.0,已改回)。
 */
const REAL_SPEECH_RATE_STEPS = [
  { value: 0.9, label: "慢 0.9" },
  { value: 1.1, label: "正常 1.1" },
  { value: 1.2, label: "快 1.2" },
  { value: 1.3, label: "最快 1.3" },
] as const;

/** 与后端原兜底值同源(见上方头注),不是随手挑的"看起来正常"的数。 */
const DEFAULT_VOICE_SPEECH_RATE = 1.1;

/** 就近落档(存量草稿可能带连续值)—— 高亮最近的一档,不改已存值直到用户点选。 */
function nearestRealSpeechStep(rate: number): number {
  let best: number = REAL_SPEECH_RATE_STEPS[0].value;
  for (const s of REAL_SPEECH_RATE_STEPS) {
    if (Math.abs(s.value - rate) < Math.abs(best - rate)) best = s.value;
  }
  return best;
}

/**
 * P0.6(0915 任务书车 V):契约字段 `keepSourceAudio` 已落定,开关放开。
 * 「保留参考视频原声」(换我出镜专属)—— 开启后 ai 成片合成阶段把参考视频里的原声/
 * 环境音混进成片,与口播/BGM 走现有 ducking/音量档;参考视频没有声轨则静默跳过、
 * 不影响出片。
 */
const KEEP_SOURCE_AUDIO_READY = true;

/**
 * 换我出镜:userInput 默认模板(0915 契约钉死批)——「补充说明」语义是场景/多人指定,
 * 不是口播文案,拼进 userInput 时要接在一句说清楚"这是换脸任务"的默认模板后面,
 * 不能让 userInput 只剩用户那句可能为空的补充说明。
 */
const SWAP_DEFAULT_USER_INPUT = "参考视频的画面、运镜、节奏保持不变,只把出镜人换成所选人物。";

/**
 * 文案出片「想拍什么」空态引导 —— 逐字对齐自由创作页的直发提示词教学
 * (0915 拍板「参考自由创作」;本页同为直发,引导口径必须同源)。
 */
const TEXT_INPUT_PLACEHOLDER =
  "直接写给视频模型的提示词,越具体越好:主体 + 动作 + 运镜 + 景别 + 光线 + 氛围。\n例:老板面带微笑走向镜头,办公室场景,暖调,浅景深。\n\n也可以整段粘现成脚本,原样直发。";

function initialForm(): FormState {
  return {
    userInput: "",
    name: "",
    useAutoModel: false,
    provider: REAL_PERSON_PROVIDER,
    model: DEFAULT_REAL_PERSON_MODEL,
    generationMode: "T2V",
    resolution: VIDEO_DEFAULT_RESOLUTION,
    ratio: "9:16",
    durationSec: REAL_PERSON_DEFAULT_DURATION_SEC,
    generateAudio: false,
    source: "FREE",
    storyMode: false,
    bgmId: null,
    customBgmObjectKey: null,
    voiceTone: NEUTRAL_VOICE_TONE,
    // P0.6(0915 车 I):语速两条路(声纹/预置)都吃,给个默认档,不留 undefined 让语速
    // chip 组渲染时没有选中态。★钉死 = DEFAULT_VOICE_SPEECH_RATE(=1.1,与后端原
    // 兜底值同源),不是 1.0——这个字段此前真人页根本不发,默认值必须原样接过后端
    // 已经在用的兜底值,否则加控件本身就是一次静默降速。
    voiceSpeechRate: DEFAULT_VOICE_SPEECH_RATE,
  };
}

type Mode = RealPersonMode;

/** 本页时长档的值列表(模板推荐时长落档用)。 */
const textDurationValues = (model: RealPersonModelId): readonly number[] =>
  textDurationOptions(model).map((d) => d.value);
const RATIO_VALUES: readonly string[] = RATIO_OPTIONS.map((r) => r.value);

/**
 * 1011 算法备案:真人出镜无国内实现 —— domesticOnly 租户直链 / 书签进来一律回视频舱首页
 * (入口卡已隐藏,api 侧同时拒绝)。包一层守卫,不动下面页面本体的 hooks 顺序。
 */
export default function VideoRealCreatePage() {
  const { domesticOnly } = useCompliance();
  if (domesticOnly) return <Navigate to="/ai-video" replace />;
  return <VideoRealCreatePageInner />;
}

function VideoRealCreatePageInner() {
  const navigate = useNavigate();
  const [pick, setPick] = useState<CharacterPick | null>(null);
  const [resolvingId, setResolvingId] = useState<number | null>(null);
  const [mode, setMode] = useState<Mode>("text");
  const [form, setForm] = useState<FormState>(initialForm);
  const [submitError, setSubmitError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  // ── 换我出镜(0924 降为「高级玩法」折叠区):参考视频体检/上传拆进 useSwapReference ──
  const swap = useSwapReference();
  const [advancedOpen, setAdvancedOpen] = useState(false);
  const [swapNote, setSwapNote] = useState("");
  /**
   * D2(0925 收尾波):第三方视频换脸合规口 —— 默认不勾,未勾选禁止提交;
   * 勾选状态随请求体发 `swapUsageRightConfirmed`(api 本波未加字段,`@JsonIgnoreProperties`
   * 会静默丢掉、不落库;前端先发,等 api 补上)。
   */
  const [swapUsageRightConfirmed, setSwapUsageRightConfirmed] = useState(false);
  const swapIssue = swap.issue;
  const swapObjectKey = swap.objectKey;
  const swapUploading = swap.uploading;
  const swapChecking = swap.checking;
  /** 提交/报价用整数秒(原始时长四舍五入,不钳 —— 超档由 swapVerdict 拦)。 */
  const swapDurationSec =
    swap.rawDurationSec != null ? swapPayloadDurationSec(swap.rawDurationSec) : null;
  /**
   * 0924 车 B:文案出片「带上产品」—— 复用通用创建页的 ProductImagePanel(产品库选品 = 产品
   * main 槽 key;上传 = uploadFrame key 过分类)。**只上送派生出的 productRefKey**(契约 §3.3),
   * 产品实体不并进 entities:真人任务的 entities 由 applyCharacterPick 独占(api 靠它认真人)。
   * ai 真人 bare 路把 productRefKey 编成 role=product 参考、与 identity 同槽。
   */
  const [productEntities, setProductEntities] = useState<VideoEntity[]>([]);
  const [productRefKey, setProductRefKey] = useState("");

  // ── 声音与配乐(单页化后右侧栏常驻,不再折叠)────────────────────────
  const [voiceoverOn, setVoiceoverOn] = useState(false);
  const [voiceoverText, setVoiceoverText] = useState("");
  // 1016 V1:对镜说话 / 旁白(默认旁白,零回归;只在文案出片展示与生效)。
  const [speechMode, setSpeechMode] = useState<RealPersonSpeechMode>(
    DEFAULT_REAL_PERSON_SPEECH_MODE
  );
  const [subtitleOn, setSubtitleOn] = useState(true);
  /**
   * P0.6(0915 车 I,声音区对齐数字人):口播音色二选一 —— "profile" = 用列表里选中的
   * 那条声纹(`profileId`,可能是出镜人自己绑定的,也可能是租户其他声纹);"preset" =
   * `VOICE_OPTIONS` 预置音色(现状不变)。出镜人带 `voiceProfileId` 时默认 "profile"
   * 且 `profileId` 预填成 ta 自己的那条;没带声纹的人物恒 "preset"。
   * 与 `form.voiceTone` 互斥:"profile" 时提交 `voiceProfileId`、不发 `voiceTone`。
   */
  const [voiceKind, setVoiceKind] = useState<"profile" | "preset">("preset");
  const [profileId, setProfileId] = useState<string | null>(null);
  /**
   * 声音 V2 三件套(P0.6 0915 车 I):语言/方言/演绎方式。只对「我的声纹」(`voiceKind
   * === "profile"`)真实生效 —— 预置音色是旧引擎,选中时这段整体禁用置灰(抄数字人页
   * 「不整体消失」的处理方式:能力常驻可见,用户才知道换到声纹能解锁什么)。
   */
  const [voiceLanguage, setVoiceLanguage] = useState<string>(DH_DEFAULT_VOICE_LANGUAGE);
  const [voiceDialect, setVoiceDialect] = useState<string | null>(null);
  const [voiceStyle, setVoiceStyle] = useState<string>(DH_DEFAULT_VOICE_STYLE);
  const onChangeVoiceLanguage = (v: string) => {
    setVoiceLanguage(v);
    // ★方言依附语言(契约钉死):仅中文可非空,换语言顺手清空方言 —— 抄数字人页
    // `onChangeVoiceLanguage` 的同一处理,不能让"选了法语但方言还留着川话"这种半吊子态存在。
    if (v !== "zh") setVoiceDialect(null);
  };
  // 组合试听(P0.6 0915 车 I):按当前 声纹/预置 × 语言 × 方言 × 演绎 × 语速 现合成一小段。
  const [previewingVoice, setPreviewingVoice] = useState(false);
  const [voicePreviewUrl, setVoicePreviewUrl] = useState<string | null>(null);
  const [keepSourceAudio, setKeepSourceAudio] = useState(false);
  /**
   * 身份参考档(0915 归一批 B「身份参考可选」;0920 三态化,用户反馈「只能选照片,不能单选视频」)。
   *
   * ★缺省 photo = 只用照片。两条依据:
   *   ① 老板实观「一张定妆照效果就够好,多图更好」;
   *   ② vin 与 novin **单价完全一样**,差别只在计量(qty = 出片秒 + 身份视频秒)——
   *      身份视频封顶 15s 是固定开销,摊不薄:15s 的片贵一倍,5s 的片贵四倍。
   *
   * ★0920 升成三态:此前是布尔,两个值都带着照片,表达不了「这一单就照着我这段视频来,
   *   别拿照片」。第三档 video 与 photo_video **同价同量**(vapeur 只要收到视频输入就走
   *   vin 计费码,少送一张图不会让价格变低),差别只在送哪些参考。
   *
   * ★此前**没有这个开关**:console 按「人物有没有挂视频」自动决定,人物一旦传过口播视频,
   * 之后每一单都自动带上、自动按双倍计量,页面上既没开关也没提示。
   */
  const [identityRefMode, setIdentityRefMode] =
    useState<IdentityRefMode>(DEFAULT_IDENTITY_REF_MODE);
  const [bgmTab, setBgmTab] = useState<"preset" | "custom">("preset");
  const [customBgmFile, setCustomBgmFile] = useState<File | null>(null);
  const [customBgmUrl, setCustomBgmUrl] = useState<string | null>(null);
  const [uploadingBgm, setUploadingBgm] = useState(false);

  const charactersQuery = useQuery({
    queryKey: ["characters"],
    queryFn: () => characterService.list(),
  });
  // 声纹库(P0.6 0915 车 I):复用数字人页读声纹库的同一个 query/service —— 同 queryKey
  // 命中同一份缓存(两个 feature 各自 import entities/dh-profile,互不知道对方存在)。
  const voiceProfilesQuery = useQuery({
    queryKey: ["dh", "voice-profiles"],
    queryFn: () => dhProfileService.listVoiceProfiles(),
  });
  const voiceProfiles: VoiceProfileDto[] = voiceProfilesQuery.data?.profiles ?? [];
  // ★1006:分身仓建的人物(只有分身口播素材,realPersonEligible=false)不进真人出镜选人。
  const realChars = (charactersQuery.data ?? []).filter(
    (c) => c.status === "active" && c.isRealPerson && realPersonEligibleOf(c)
  );

  const bgmsQuery = useQuery({
    queryKey: ["video-bgms-real-create"],
    queryFn: () => videoService.listBgms(),
    meta: { suppressGlobalErrorToast: true },
  });
  const bgms: VideoBgmDto[] = bgmsQuery.data ?? [];

  // 当前选中模型档的能力(时长上限 / 支持分辨率)—— UI 渲染与联动钳位唯一读它,
  // 不许各处各自维护第二份"fast/mini 没有 1080p"这类判据。
  const modelTier = realPersonModelTier(form.model);

  /**
   * 切模型档 —— 分辨率 / 时长(文案出片档 + 换我出镜已测出的参考视频时长)联动钳位。
   * ★两把尺各自独立判断要不要钳(不是"只要切模型就全钳一遍"):没超新档能力的字段原样不动,
   * 钳了才提示,不许在没发生任何变化时也弹一条空话的 toast。
   */
  const onPickModel = (next: RealPersonModelId) => {
    if (form.model === next) return;
    const nextTier = realPersonModelTier(next);
    const notices: string[] = [];
    setForm((s) => {
      const nextResolution = clampResolutionForModel(s.resolution, next);
      if (nextResolution !== s.resolution) {
        notices.push(`分辨率已回落到 ${nextResolution}(「${nextTier.label}」不支持 1080p)`);
      }
      let nextDurationSec = s.durationSec;
      if (mode === "text") {
        nextDurationSec = clampDurationForModel(s.durationSec, next);
        if (nextDurationSec !== s.durationSec) {
          notices.push(
            `时长已调整为 ${nextDurationSec}s(「${nextTier.label}」最长支持 ${nextTier.maxDurationSec} 秒)`
          );
        }
      }
      return { ...s, model: next, resolution: nextResolution, durationSec: nextDurationSec };
    });
    // ★0924:换我出镜参考视频时长**不再跟着钳**(存原始时长,契约 §3.4)——
    //   换到装不下的档由 swapVerdict 当场提示「切 2.5」,不静默改小。
    if (notices.length > 0) {
      toast({ title: "已按模型档位调整", description: notices.join(";") });
    }
  };

  const handleCustomBgmUpload = async (f: File) => {
    if (!/^audio\/(mpeg|mp3)$/.test(f.type)) {
      setSubmitError("仅支持 audio/mpeg (mp3)");
      return;
    }
    if (f.size > 10 * 1024 * 1024) {
      setSubmitError("BGM 文件需 ≤10MB");
      return;
    }
    setUploadingBgm(true);
    setSubmitError(null);
    try {
      const { objectKey, url } = await videoService.uploadCustomBgm(f);
      setCustomBgmFile(f);
      setCustomBgmUrl(url);
      setForm((s) => ({ ...s, bgmId: null, customBgmObjectKey: objectKey }));
    } catch (e) {
      setSubmitError(errorText(e));
    } finally {
      setUploadingBgm(false);
    }
  };

  const onPickCharacter = async (c: CharacterDto) => {
    if (realPersonPickState(c) !== "selectable" || resolvingId != null) return;
    // 单页化:重复点当前已选的人是无义动作,直接忽略(换人才重新解析)。
    if (pick?.character.id === c.id) return;
    setResolvingId(c.id);
    try {
      const resolved = await resolveCharacterPick(c);
      // ★拍板点 D:换出镜人**不清空**已填内容(文案/参考视频/声音设置全保留)——
      // 单页化后换人是零成本动作,清空反而惩罚用户。
      setPick(resolved);
      // 身份参考档跟着人走(0920):缺省仍是定妆照;唯一的例外是这个人**只有身份视频、
      // 没有任何定妆照**——那时落在定妆照档上是个实际不可用的缺省(提交必被 api 的素材
      // 就绪守卫拒掉,而用户看不出为什么)。判据单点在 defaultIdentityRefMode。
      setIdentityRefMode(defaultIdentityRefMode(resolved.character));
      // ★音色联动(P0.6 车 I):选人联动的不是 voiceTone(仍是 initialForm 的中性默认档),
      // 而是声纹列表要不要默认选中出镜人自己那条——出镜人带 voiceProfileId 就默认选中
      // (人物绑定态),没带就落回预置列表。
      if (resolved.character.voiceProfileId != null) {
        setVoiceKind("profile");
        setProfileId(String(resolved.character.voiceProfileId));
      } else {
        setVoiceKind("preset");
        setProfileId(null);
      }
    } catch (e) {
      toast(errorToast(e, { fallbackTitle: "选人失败" }));
    } finally {
      setResolvingId(null);
    }
  };

  // ═══ 入参三通道 + 写脚本(0924 车 D 二期,契约 §3.4)—— 逻辑在 useRealPersonBrief ═══
  const brief = useRealPersonBrief({
    form,
    setForm,
    setMode,
    pick,
    voiceoverText,
    setVoiceoverText,
    realChars,
    charactersLoading: charactersQuery.isLoading,
    onPickCharacter,
    durationValues: textDurationValues,
    ratioValues: RATIO_VALUES,
  });
  const { activeTemplate, explosive, scriptWriter } = brief;

  const leftoverSlots = mode === "text" ? unfilledSlots(form.userInput) : [];

  /**
   * 声音 V2 组合试听(P0.6 0915 车 I):按「声纹/预置音色 × 语言 × 方言 × 演绎 × 语速」
   * 现合成一小段。文案取口播文案前 30 字(空文案用占位句)——试听是给「组合对不对」
   * 听个感觉,不是全文预渲染。两条路(声纹/预置)都可试听:声纹路要先选中具体一条。
   * 失败只 toast,不落 error 态(error 位是出片主链路的)。
   */
  const previewVoiceCombo = async () => {
    if (previewingVoice) return;
    if (voiceKind === "profile" && !profileId) return;
    setPreviewingVoice(true);
    try {
      const text =
        voiceoverText.trim().slice(0, 30) || "大家好,先听听这个声音组合念起来是什么感觉。";
      const r = await videoService.previewVoice({
        ...(voiceKind === "profile"
          ? { voiceProfileId: Number(profileId) }
          : { presetVoice: form.voiceTone ?? NEUTRAL_VOICE_TONE }),
        text,
        // ★语言/方言/演绎只对声纹真实生效(与提交任务同口径)——预置路仍要传满这三个
        //   必填字段(接口签名要求),给默认值即可,后端本就会忽略它们。
        //   1006:旧版声纹同理(voiceTuningUnlocked=false)→ 给默认值。
        voiceLanguage: voiceTuningUnlocked ? voiceLanguage : DH_DEFAULT_VOICE_LANGUAGE,
        voiceDialect: voiceTuningUnlocked && voiceLanguage === "zh" ? voiceDialect : null,
        voiceStyle: voiceTuningUnlocked ? voiceStyle : DH_DEFAULT_VOICE_STYLE,
        // ★字段名陷阱:试听端点吃 speechRate,提交任务吃 voiceSpeechRate(同一个量两个
        //   名字,详见 videoService.ts VideoVoicePreviewRequest 头注)。
        speechRate: form.voiceSpeechRate ?? DEFAULT_VOICE_SPEECH_RATE,
      });
      setVoicePreviewUrl(r.audioUrl);
    } catch (e) {
      toast(errorToast(e, { fallbackTitle: "试听失败" }));
    } finally {
      setPreviewingVoice(false);
    }
  };

  // ── 积分预估(走现有报价口,dryRun)────────────────────────────────
  const { book } = usePriceBook();
  // ★vin 族报价修正(0915 车 E,方案 a):计量口径全收口进 realPersonQuoteMetrics 纯函数
  // (../model/realPersonModelTiers.ts)—— 页面不再自己判 hasVideoInput/拼 qty。两处此前
  // 漏计量:①文案出片对挂了视频形象的人物(`pick.character.hasVideoAvatar`)提交会带身份
  // 参考视频,要走 vin 档且 qty 加上身份视频秒数;②换我出镜 vin 形态 token=(输入+输出),
  // qty 要按参考视频秒的 2 倍算。这里只喂计量,提交 payload 的 hasVideoInput/durationSec
  // 判据不变(仍在 onSubmit 里各走各的字段)。
  const quoteMetrics = useMemo(
    () =>
      realPersonQuoteMetrics({
        mode,
        model: modelTier.value,
        resolution: form.resolution,
        durationSec: form.durationSec,
        swapDurationSec,
        // ★人物没挂视频时单选组整组不出现,identityRefMode 恒缺省 photo —— 这里不再
        //   叠一层 `hasVideoAvatar &&`:那就是第二处判据,与 identityRefOptions 分叉的起点。
        identityRefMode,
        identityVideoDurationSec: pick?.character.identityVideoDurationSec,
      }),
    [
      mode,
      modelTier.value,
      form.resolution,
      form.durationSec,
      swapDurationSec,
      pick?.character.identityVideoDurationSec,
      identityRefMode,
    ]
  );
  const quoteParams = useMemo(() => {
    if (!book.ready || !quoteMetrics) return null;
    const variantKey = book.variantByModel(
      SKU.video,
      quoteMetrics.modelCode,
      quoteMetrics.variantSuffix
    );
    // 查不到价 → 不显示估算(沿用现有行为,不猜一个数)。
    return variantKey ? { skuCode: SKU.video, variantKey, qty: quoteMetrics.qty } : null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [book.ready, quoteMetrics]);
  const { credits: estimatedCredits } = useQuotePreview(quoteParams);

  /**
   * 带身份视频要多花多少积分 —— **加价当场显示**,不让人提交完看账单才知道。
   *
   * 算法上不另发一次报价:vin 与 novin **单价完全一样**(价表实证:同分辨率同模型的
   * qty_scale_bp / markup_bp 一分不差),差别只在 qty = 出片秒 + 身份视频秒。
   * 所以差价 = 当前每秒价 × 身份视频秒 —— 用已拿到的报价反推单价即可。
   */
  /**
   * 身份参考单选组的三档(0920)。人物没挂身份视频时返回空数组 = 整组不渲染
   * (只能选一档的单选组是纯噪声,与 0915 判据一致)。含定妆照的两档在「这个人只有视频」
   * 时置灰 —— 点了也不可能成功(api 选不出图素材),置灰并把原因摆在明面上。
   */
  const identityRefChoices = useMemo(
    () => (pick ? identityRefOptions(pick.character) : []),
    [pick]
  );
  const identityRefDisabledReason = identityRefChoices.find((o) => o.disabled)?.disabledReason;

  const vinExtraCredits = useMemo(() => {
    const idSec = pick?.character.identityVideoDurationSec;
    if (!estimatedCredits || !quoteMetrics?.qty || !idSec) return null;
    const perUnit = estimatedCredits / quoteMetrics.qty;
    return Math.round(perUnit * idSec);
  }, [estimatedCredits, quoteMetrics?.qty, pick?.character.identityVideoDurationSec]);

  /** 换我出镜时长按档判定(随所选模型实时重算;契约 §3.4)。 */
  const swapVerdict = assessSwapDuration(swap.rawDurationSec, modelTier.value);
  const canSubmitText = !!pick && form.userInput.trim().length > 0;
  const canSubmitSwap =
    !!pick &&
    !!swapObjectKey &&
    !swapIssue?.blocksSubmit &&
    !swapUploading &&
    !swapVerdictBlocksSubmit(swapVerdict) &&
    swapUsageRightConfirmed;
  const canSubmit = mode === "text" ? canSubmitText : canSubmitSwap;

  /**
   * ★错配防呆(P0.6 0915 车 I):出镜人绑定的声纹与当前选中声纹不是同一条时给一句轻提示
   * (不拦提交)——现网真实事故:人物「阿杰」绑的声纹 label 叫「彭姐」、实测 F0 207.8Hz
   * 是女声,页面上完全看不出绑的是哪条,静默错配。声纹列表现在显示真实名字,这里再补一句
   * 主动提醒,双保险。找不到 boundProfile(不在当前可见声纹列表里)时退回显示 id,
   * 不编一个名字。
   */
  const boundVoiceProfileId = pick?.character.voiceProfileId ?? null;
  const boundVoiceProfile =
    boundVoiceProfileId != null ? voiceProfiles.find((p) => p.id === boundVoiceProfileId) : null;
  // ★1006 旧版声纹(supportsTuning===false,cosyvoice 时代录的):三件套不生效 → 与预置同样锁定,
  //   提交/试听不带三件套。字段缺省(老后端)按支持处理,不误锁。口径同数字人创建页。
  const selectedVoiceProfile =
    voiceKind === "profile" ? voiceProfiles.find((p) => String(p.id) === profileId) : undefined;
  const legacyProfileSelected =
    !!selectedVoiceProfile && !voiceProfileSupportsTuning(selectedVoiceProfile);
  const voiceTuningUnlocked = voiceKind === "profile" && !legacyProfileSelected;
  const voiceProfileMismatch =
    voiceKind === "profile" &&
    boundVoiceProfileId != null &&
    profileId !== String(boundVoiceProfileId);

  /**
   * ★拍板点 B「一眼看懂」:底部条任何时刻都告诉用户「还差什么」;条件齐了就换成
   * 当前选择的摘要句。判据必须与 canSubmit 同源推导,不许各自维护第二份。
   */
  const missingHint = !pick
    ? "选一位出镜人"
    : mode === "text"
      ? form.userInput.trim()
        ? null
        : "写一句想拍的画面"
      : swapUploading
        ? "参考视频上传中…"
        : swapChecking
          ? "参考视频体检中…"
          : swapVerdict.kind === "over_max"
            ? `换一段 30 秒以内的参考视频`
            : swapVerdict.kind === "needs_long_tier"
              ? "参考视频超过当前档时长,切到「旗舰」档"
              : !swapObjectKey || swapIssue?.blocksSubmit
                ? "上传一段能用的参考视频"
                : !swapUsageRightConfirmed
                  ? "勾选「我确认对该视频拥有使用权并已获得出镜者授权」"
                  : null;

  // 口播按哪段时长截:换我出镜跟参考视频走,文案出片跟所选时长走(与提交 payload 同源)。
  const voiceoverDurationSec =
    mode === "swap" ? (swapDurationSec ?? form.durationSec) : form.durationSec;

  const onSubmit = async () => {
    if (!pick || submitting) return;
    setSubmitError(null);
    if (mode === "text" && !form.userInput.trim()) {
      setSubmitError("请填写文案描述");
      return;
    }
    if (mode === "swap" && swapVerdictBlocksSubmit(swapVerdict)) {
      setSubmitError("参考视频超过所选档位的时长,先按提示切档或换一段");
      return;
    }
    if (mode === "swap" && !swapObjectKey) {
      setSubmitError(swapUploading ? "参考视频还在上传,请稍候" : "请先上传一段能用的参考视频");
      return;
    }
    if (mode === "swap" && !swapUsageRightConfirmed) {
      setSubmitError("请先勾选「我确认对该视频拥有使用权并已获得出镜者授权」");
      return;
    }
    setSubmitting(true);
    try {
      // ★两把尺共用同一条通路(0913/0914 D 车的老结论):选人后注入 entities/references
      // 的是 `applyCharacterPick`(characterPick.ts),api A4 靠 entities 里的 LIBC 真人
      // 实体识别"这是一条真人任务"、附 realPersonCast——这里必须走它,不能自己拼 entities。
      const charForm = applyCharacterPick(form, pick);
      // ★0915 契约钉死批(G5 已修三面断链):直发单镜用「逐镜数组取长度 1」表达单镜口播 ——
      // voiceovers/speechModes 都是长度 1 的数组,配 voiceEnabled 这个新开关一起发。
      // P0.6(0915 车 I,声音区对齐数字人):voiceKind==="profile" 时发 voiceProfileId +
      // 语言/方言/演绎三件套、不发 voiceTone(优先级钉死,api/ai 两端在场即用、不读
      // voiceTone);否则走现行预置 voiceTone,三件套整段不发(预置音色不认这三个参数,
      // 带了也被后端静默忽略——干脆不带,payload 干净)。
      const useVoiceProfile = voiceKind === "profile" && profileId != null;
      const voiceExtras: Partial<VideoTaskCreateRequest> = {
        voiceEnabled: voiceoverOn,
        ...(voiceoverOn && voiceoverText.trim()
          ? {
              voiceovers: [voiceoverText.trim()],
              speechModes: realPersonSpeechModes(mode, speechMode),
              ...(useVoiceProfile
                ? // ★显式覆写成 undefined,不能只是"不设它"——buildTaskRequest 已经把
                  // form.voiceTone(默认中性档)铺进了 req 的底层展开,voiceExtras 要能
                  // 盖掉那份默认值,否则「不发 voiceTone」的承诺在 useVoiceProfile 分支落空。
                  {
                    voiceProfileId: Number(profileId),
                    voiceTone: undefined,
                    // 旧版声纹:三件套不生效,不上送(锁定态下的值只是残影)。
                    ...(legacyProfileSelected
                      ? {}
                      : {
                          voiceLanguage,
                          voiceDialect: voiceLanguage === "zh" ? voiceDialect : null,
                          voiceStyle,
                        }),
                  }
                : { voiceTone: charForm.voiceTone ?? undefined }),
            }
          : {}),
      };
      const subtitleExtras: Partial<VideoTaskCreateRequest> = {
        subtitleEnabled: subtitleOn,
        ...(subtitleOn ? { subtitleFontScale: charForm.subtitleFontScale ?? "medium" } : {}),
      };
      const bgmSelected = !!(form.bgmId || form.customBgmObjectKey);
      const bgmExtras: Partial<VideoTaskCreateRequest> = { bgmEnabled: bgmSelected };

      if (mode === "text") {
        /**
         * ★0916 补断链:人物卡(外观一句话)此前**只有通用视频创建页**拼进 userInput,
         * 真人出镜专属页从来没拼过 —— 而归一后 `appearance` 是人物身上**唯一**进提示词链的
         * 文本(角色卡 12 字段零消费面已整块退役)。不拼 = 选了谁只影响参考图,
         * 「方脸/藏蓝工装/黑色齐肩短发」这些用户认真写下的字一个都到不了模型,
         * 虚拟人那条线尤其吃亏(它没有真人照片那么强的图锚)。
         * 换我出镜(R2V_SWAP)不拼:身份完全由参考视频给,再补一段文字外观只会打架。
         */
        const finalForm: FormState = {
          ...charForm,
          userInput: withCharacterSheet(charForm.userInput, charForm),
          // 0924 车 B:带上产品(空 = 不带,字段不出现)。
          productRefKey: productRefKey || null,
        };
        const quoteId = await acquireQuoteId(quoteParams);
        const req: VideoTaskCreateRequest = {
          ...buildTaskRequest({
            form: finalForm,
            // ★内部模型 id 发所选档(form.model),provider 恒 "seedance"(契约逐字)。
            effectiveModel: { provider: REAL_PERSON_PROVIDER, model: modelTier.value },
            effectiveMode: "T2V",
            quoteId,
            bareSendMaxSec: modelTier.maxDurationSec,
          }),
          // 身份参考可选(0915 归一批 B;0920 三态化):只在文案出片这条路有意义 ——
          // 「换我出镜」本身就是传视频进去,恒 vin,没有可选。
          identityRefMode,
          // ★旧布尔的**兼容镜像**:api 侧两者都给时以新字段为准(IdentityRefMode.resolve),
          //   这里发它是为了万一 console 先上线、api 还是旧版 —— 旧版读到镜像至少还落在
          //   「带视频」这一族,不会把用户选的「仅身份视频」静默读成只用照片。
          identityUseVideo: identityRefBillsAsVideoInput(identityRefMode),
          ...voiceExtras,
          ...subtitleExtras,
          ...bgmExtras,
        };
        const { taskId } = await videoService.createTask(req);
        navigate(`/ai-video/tasks/${taskId}`);
        return;
      }

      // 换我出镜:R2V_SWAP。ratio 走占位值(服务端按参考视频实际画幅走,不读这个字段);
      // durationSec 显式覆盖成参考视频**原始**时长的整数秒(0924 起不钳:超档已由 swapVerdict
      // 拦在前面,api 按模型查表再判一次 → 422 SWAP_DURATION_EXCEEDS_TIER);
      // userInput = 默认模板 + 可选的场景/多人指定说明(换行接在模板后,不是口播文案)。
      const swapUserInput = swapNote.trim()
        ? `${SWAP_DEFAULT_USER_INPUT}\n${swapNote.trim()}`
        : SWAP_DEFAULT_USER_INPUT;
      const finalForm: FormState = {
        ...charForm,
        userInput: swapUserInput,
        ratio: SWAP_RATIO_PLACEHOLDER,
      };
      const quoteId = await acquireQuoteId(quoteParams);
      const built = buildTaskRequest({
        form: finalForm,
        effectiveModel: { provider: REAL_PERSON_PROVIDER, model: modelTier.value },
        effectiveMode: "R2V_SWAP",
        quoteId,
        bareSendMaxSec: modelTier.maxDurationSec,
      });
      const req: VideoTaskCreateRequest = {
        ...built,
        durationSec: swapDurationSec ?? built.durationSec,
        swapRefKey: swapObjectKey!,
        // P0.6(任务书车 V):「保留参考视频原声」——仅这条(R2V_SWAP)路读,api/ai 两端
        // 都对非 R2V_SWAP 任务宽容忽略这个字段,故此处不需要额外的模式判断。
        keepSourceAudio,
        // D2(0925 收尾波):走到这里 canSubmit/onSubmit 双闸都已确认勾选过,恒 true——
        // api 这批未接字段会被 @JsonIgnoreProperties 静默丢掉,前端先发不等 api。
        swapUsageRightConfirmed: true,
        ...voiceExtras,
        ...subtitleExtras,
        ...bgmExtras,
      };
      const { taskId } = await videoService.createTask(req);
      navigate(`/ai-video/tasks/${taskId}`);
    } catch (e) {
      // 0924:确定性错误(超档/出镜人解不出/参考视频被拒)给专属人话,不再是通用「请重试」。
      setSubmitError(realPersonSubmitErrorText(e));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    // ★容器宽度:与通用创建页同口径 w-full 铺满 + xl:pr-14 悬浮球球道(0810 满屏批拍板;
    // 0915 老板二次点名「页面没有充满屏幕」——初版误用 max-w-4xl,1920 下两侧空转 1000px+)。
    <div className="w-full space-y-5 xl:pr-14">
      <PageHeader
        icon={Sparkles}
        title="真人出镜"
        subtitle="选一位人物出镜,写句话或套一条样片脚本,直接出片。"
        backTo="/ai-video"
      />

      {/* ── 样片墙(0924 车 D 二期):顶部横向卡墙,「用这个拍」预填脚本与参数。 ── */}
      <RealPersonSampleWall
        activeTemplateId={activeTemplate?.id ?? null}
        onUse={brief.applyTemplate}
      />

      {/* ★单页三区块(0915 拍板):无步骤条,桌面右侧栏放声音配乐,窄屏纵向堆回主列。 */}
      <div className="grid items-start gap-5 xl:grid-cols-[minmax(0,1fr)_340px]">
        <div className="min-w-0 space-y-5">
          {/* ── 区块 1 · 谁来出镜 ───────────────────────────────────── */}
          <section data-testid="real-section-cast">
            <SectionHead num={1} title="谁来出镜" hint="点选即可,换人不丢已填内容" />
            {charactersQuery.isLoading ? (
              <div className="flex gap-3 overflow-x-auto pb-1" data-testid="real-char-skeleton">
                {Array.from({ length: 4 }).map((_, i) => (
                  <div
                    key={i}
                    className="fx-skeleton h-[76px] w-[200px] shrink-0 rounded-[calc(var(--radius)*1.2)]"
                  />
                ))}
              </div>
            ) : realChars.length === 0 ? (
              <div
                data-testid="real-char-empty"
                className="rounded-lg border border-dashed border-border/70 px-6 py-10 text-center"
              >
                <UserRound className="mx-auto h-8 w-8 text-muted-foreground opacity-50" />
                <p className="mt-3 text-sm font-medium">还没有真人出镜人</p>
                <p className="mt-1 text-xs text-muted-foreground">
                  先去建一位 —— 一张正脸照片(或一段口播视频),几分钟就能建好。
                </p>
                <Button
                  className="mt-4"
                  onClick={() => navigate("/characters/new-real?returnTo=/ai-video/real")}
                >
                  ＋新建出镜人
                  <ArrowRight className="ml-2 h-4 w-4" />
                </Button>
              </div>
            ) : (
              <div className="flex gap-3 overflow-x-auto pb-1">
                {realChars.map((c) => (
                  <RealPersonCard
                    key={c.id}
                    c={c}
                    selected={pick?.character.id === c.id}
                    resolving={resolvingId === c.id}
                    onPick={() => void onPickCharacter(c)}
                  />
                ))}
                <button
                  type="button"
                  data-testid="real-char-add-tail"
                  onClick={() => navigate("/characters/new-real?returnTo=/ai-video/real")}
                  className={cn(
                    "flex min-h-[76px] w-[150px] shrink-0 items-center justify-center gap-2 border border-dashed border-border/70 text-sm text-muted-foreground transition-colors hover:border-primary/60 hover:text-primary",
                    CARD_WALL_RADIUS
                  )}
                >
                  <UserRound className="h-4 w-4" />
                  ＋新建出镜人
                </button>
              </div>
            )}

            {/*
              身份参考(0915 归一批 B)。★只在**选中的人物真的有身份视频**时才出现 ——
              没有视频的人物看到一个只能选一档的单选组,是纯噪声。
              「换我出镜」模式本身就是传视频进去,不适用这个选择(它恒 vin)。
            */}
            {mode === "text" && identityRefChoices.length > 0 && (
              <div
                data-testid="real-identity-ref"
                className="mt-3 flex flex-wrap items-center gap-x-3 gap-y-2 rounded-[calc(var(--radius)*1.15)] border bg-muted/30 px-4 py-3"
              >
                <span className="text-sm font-medium">身份参考</span>
                {identityRefChoices.map((o) => (
                  <button
                    key={o.value}
                    type="button"
                    disabled={o.disabled}
                    title={o.disabledReason}
                    aria-pressed={identityRefMode === o.value}
                    onClick={() => setIdentityRefMode(o.value)}
                    className={cn(
                      "rounded-md border px-3 py-1.5 text-xs transition-colors",
                      identityRefMode === o.value
                        ? "border-primary/55 bg-primary/10 font-semibold text-foreground"
                        : "border-border text-muted-foreground hover:text-foreground",
                      o.disabled && "cursor-not-allowed opacity-45 hover:text-muted-foreground"
                    )}
                  >
                    {o.label}
                    {/* 加价当场显示:两个带视频的档都要标,别让人提交完看账单才知道。 */}
                    {o.billsAsVideoInput && vinExtraCredits != null && (
                      <span className="ml-1.5 text-2xs text-warning">
                        ＋{vinExtraCredits.toLocaleString()} 积分
                      </span>
                    )}
                  </button>
                ))}
                {/* ★一句话讲清三档的差别与钱(0920 三态化后重写:旧文案只讲得通两档)。 */}
                <span className="basis-full text-2xs text-muted-foreground">
                  一张定妆照通常就够。两个带身份视频的档会把视频的画面用量一起计费(单价不变,是计量变多)——
                  出片越短这笔固定开销占比越高,两档计费**完全相同**,差别只在送不送定妆照:
                  想让神态动作更贴近本人就带上视频,只想照着视频里的样子来就选「仅身份视频」。
                </span>
                {identityRefDisabledReason && (
                  <span
                    data-testid="real-identity-ref-disabled-reason"
                    className="basis-full text-2xs text-warning"
                  >
                    {identityRefDisabledReason}
                  </span>
                )}
              </div>
            )}
          </section>

          {/* ── 区块 2 · 想怎么拍(主体强调框,形制对齐自由创作 freeCreateBody)──── */}
          <section data-testid="real-section-mode">
            <SectionHead num={2} title="想怎么拍" />
            <div className="space-y-3.5 rounded-[calc(var(--radius)*1.15)] border-[1.5px] border-primary/40 bg-card/60 px-5 py-4">
              {/* 0924:玩法切换不再平铺在这里 —— 默认文案出片,「换我出镜」收进框下方「高级玩法」。 */}
              {mode === "swap" && (
                <div
                  className="text-xs font-medium text-muted-foreground"
                  data-testid="real-mode-swap-head"
                >
                  高级玩法 · 换我出镜
                </div>
              )}
              {mode === "text" && explosive && (
                <RealPersonExplosiveStrip
                  handoff={explosive}
                  writing={scriptWriter.writing}
                  onRewrite={brief.onRewriteFromExplosive}
                />
              )}
              {mode === "text" && activeTemplate && (
                <RealPersonTemplateStrip
                  template={activeTemplate}
                  slotValues={brief.slotValues}
                  onSlotChange={brief.setSlot}
                  onClear={brief.clearTemplate}
                />
              )}

              {/* ── 模型 + 分辨率(0915 车 C 放开):两种玩法共用,vapeur 真单探针验过
                    全系模型图/视频参考全通,换我出镜同样露模型档。────────────────── */}
              <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-start sm:gap-x-8">
                <div className="space-y-1.5">
                  <span className="text-xs text-muted-foreground">模型</span>
                  <OptionChipGroup label="模型">
                    {REAL_PERSON_MODEL_TIERS.map((t) => (
                      <OptionChip
                        key={t.value}
                        radio
                        active={form.model === t.value}
                        tabIndex={form.model === t.value ? 0 : -1}
                        title={t.desc}
                        onClick={() => onPickModel(t.value)}
                      >
                        {t.chipLabel}
                      </OptionChip>
                    ))}
                  </OptionChipGroup>
                </div>
                <div className="space-y-1.5">
                  <span className="text-xs text-muted-foreground">分辨率</span>
                  <OptionChipGroup label="分辨率">
                    {RESOLUTION_OPTIONS.map((r) => {
                      const disabled =
                        r.value === "1080p" && !modelTier.resolutions.includes("1080p");
                      return (
                        <OptionChip
                          key={r.value}
                          radio
                          active={form.resolution === r.value}
                          tabIndex={form.resolution === r.value ? 0 : -1}
                          disabled={disabled}
                          title={disabled ? `「${modelTier.label}」不支持 1080p` : undefined}
                          onClick={() => setForm((s) => ({ ...s, resolution: r.value }))}
                        >
                          {r.label}
                        </OptionChip>
                      );
                    })}
                  </OptionChipGroup>
                  {!modelTier.resolutions.includes("1080p") && (
                    <p className="text-2xs text-muted-foreground">
                      「{modelTier.label}」暂不支持 1080p,已锁定 480p/720p
                    </p>
                  )}
                </div>
              </div>

              {mode === "text" ? (
                <div className="space-y-3.5">
                  {/* 时长+画幅置顶(先定形状再写内容,与自由创作 0914 拍板同序)。 */}
                  <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-start sm:gap-x-8">
                    <div className="space-y-1.5">
                      <span className="text-xs text-muted-foreground">时长</span>
                      <OptionChipGroup label="时长">
                        {textDurationOptions(modelTier.value).map((d) => (
                          <OptionChip
                            key={d.value}
                            radio
                            active={form.durationSec === d.value}
                            tabIndex={form.durationSec === d.value ? 0 : -1}
                            onClick={() => setForm((s) => ({ ...s, durationSec: d.value }))}
                          >
                            {d.label}
                          </OptionChip>
                        ))}
                      </OptionChipGroup>
                    </div>
                    <div className="space-y-1.5">
                      <span className="text-xs text-muted-foreground">画幅</span>
                      <OptionChipGroup label="画幅">
                        {RATIO_OPTIONS.map((r) => (
                          <OptionChip
                            key={r.value}
                            radio
                            active={form.ratio === r.value}
                            tabIndex={form.ratio === r.value ? 0 : -1}
                            onClick={() => setForm((s) => ({ ...s, ratio: r.value }))}
                          >
                            {r.label}
                          </OptionChip>
                        ))}
                      </OptionChipGroup>
                    </div>
                  </div>
                  {/* 0924 车 B「带上产品」:人物之下、想拍什么之上(车 D 合并时挪位并拆组件)。 */}
                  <RealPersonProductPanel
                    entities={productEntities}
                    onChange={(next, key) => {
                      setProductEntities(next);
                      setProductRefKey(key);
                    }}
                    suggest={templateWantsProduct(activeTemplate) && !productRefKey}
                  />
                  <div className="space-y-1.5">
                    {/* 0915 老板:副标题提示(「这段会直接发给视频模型,写清画面就行」)去掉——
                        写什么发什么本来就是这个框的行为,不需要一行字解释它自己。 */}
                    <div className="flex items-center justify-between gap-2">
                      <Label htmlFor="real-text-input">
                        <span className="text-[13.5px] font-semibold text-foreground">
                          想拍什么
                        </span>
                      </Label>
                      {/* 0924 车 D:「帮我写脚本」—— 写好填进框,用户可改,框里是什么就发什么。 */}
                      <RealScriptButton writer={scriptWriter} onClick={brief.onWriteScript} />
                    </div>
                    <RealScriptStatus writer={scriptWriter} />
                    <Textarea
                      id="real-text-input"
                      value={form.userInput}
                      // 0915 老板:「怎么还有 500 字限制,应该放开」——对齐自由创作直发口径
                      // (那边 5000);同为「原文直发视频模型」,两个口径没理由不同源。
                      maxLength={5000}
                      placeholder={TEXT_INPUT_PLACEHOLDER}
                      onChange={(e) => setForm((s) => ({ ...s, userInput: e.target.value }))}
                      // 260px 大框:与自由创作「想拍什么」框同高,装得下一整段描述。
                      className="min-h-[260px] resize-none text-sm leading-relaxed"
                    />
                    <div className="flex items-start justify-between gap-3">
                      {leftoverSlots.length > 0 ? (
                        <p
                          data-testid="real-unfilled-slots"
                          className="text-2xs text-amber-600 dark:text-amber-400"
                        >
                          框里还有 {leftoverSlots.map((x) => `{${x}}`).join("")} 没换成你的内容 ——
                          直接出片会原样发给视频模型;手动改,或填槽位后点「帮我写脚本」。
                        </p>
                      ) : (
                        <span />
                      )}
                      <p className="shrink-0 text-right text-2xs tabular-nums text-muted-foreground">
                        {form.userInput.length} / 5000
                      </p>
                    </div>
                  </div>
                </div>
              ) : (
                <RealPersonSwapPanel
                  swap={swap}
                  verdict={swapVerdict}
                  modelLabel={modelTier.label}
                  modelMaxSec={modelTier.maxDurationSec}
                  onSwitchLongTier={() => onPickModel(SWAP_LONG_TIER_MODEL)}
                  note={swapNote}
                  onNoteChange={setSwapNote}
                  usageRightConfirmed={swapUsageRightConfirmed}
                  onUsageRightConfirmedChange={setSwapUsageRightConfirmed}
                />
              )}
            </div>
            {/* ── 高级玩法折叠区(0924 老板拍板④):换我出镜降级,收起即回文案出片。── */}
            <div className="mt-3">
              <RealPersonAdvancedPlay
                open={advancedOpen || mode === "swap"}
                onOpenChange={(open) => {
                  setAdvancedOpen(open);
                  if (!open) setMode("text");
                }}
                mode={mode}
                onModeChange={setMode}
              />
            </div>
          </section>
        </div>

        {/* ── 区块 3 · 声音与配乐(桌面右侧栏常驻;拍板点 A:不再折叠)────────── */}
        <aside className="min-w-0 xl:sticky xl:top-20" data-testid="real-section-audio">
          <SectionHead num={3} title="声音与配乐" hint="可选,不设也能出片" />
          <Card>
            <CardContent className="space-y-4 py-4">
              <div className="flex items-center justify-between">
                <div>
                  <div className="text-sm font-medium">口播</div>
                  <div className="text-2xs text-muted-foreground">
                    选一条声纹或预置音色,可选语言/方言/演绎 + 试听
                  </div>
                </div>
                <Switch checked={voiceoverOn} onCheckedChange={setVoiceoverOn} />
              </div>
              {voiceoverOn && (
                <div className="space-y-3 rounded-md border border-border/60 p-3">
                  <Textarea
                    value={voiceoverText}
                    maxLength={300}
                    rows={2}
                    placeholder="口播文案(留空则不烧字幕、不合成配音)"
                    onChange={(e) => setVoiceoverText(e.target.value)}
                  />
                  {/* 1007:念得下多少字常显;超了逐句列出会被截掉的原文(只提示不拦)。 */}
                  <VoiceoverCapHint
                    text={voiceoverText}
                    durationSec={voiceoverDurationSec}
                    subject="这条视频"
                  />

                  {/* 1016 V1:对镜说话 / 旁白。换我出镜 ai 恒按旁白,不展示。 */}
                  {mode === "text" && (
                    <div className="space-y-1.5" data-testid="real-speech-mode">
                      <Label className="text-xs">说话方式</Label>
                      <OptionChipGroup label="说话方式">
                        {REAL_PERSON_SPEECH_MODE_OPTIONS.map((o) => (
                          <OptionChip
                            key={o.value}
                            radio
                            active={speechMode === o.value}
                            tabIndex={speechMode === o.value ? 0 : -1}
                            data-testid={`real-speech-mode-${o.value}`}
                            onClick={() => setSpeechMode(o.value)}
                          >
                            {o.label}
                          </OptionChip>
                        ))}
                      </OptionChipGroup>
                      <p className="text-2xs text-muted-foreground">
                        对镜说话=人物口型对上口播;旁白=画外音,人物不张嘴。
                      </p>
                    </div>
                  )}

                  {/* ── 声纹选择(P0.6 0915 车 I):不再只有绑定那一条 —— 列出该租户可用
                      声纹,每条显示真实声纹名;人物自带的那条默认选中并标注「人物绑定」。 */}
                  <div className="space-y-1.5">
                    <div className="flex items-baseline justify-between gap-2">
                      <Label className="text-xs">我的声纹</Label>
                      {voiceProfilesQuery.isLoading && (
                        <span className="text-2xs text-muted-foreground">加载中…</span>
                      )}
                    </div>
                    {voiceProfiles.length > 0 ? (
                      <OptionChipGroup label="我的声纹">
                        {voiceProfiles.map((p) => {
                          const active = voiceKind === "profile" && profileId === String(p.id);
                          const isBound = boundVoiceProfileId === p.id;
                          return (
                            <OptionChip
                              key={p.id}
                              radio
                              active={active}
                              tabIndex={active ? 0 : -1}
                              data-testid={`real-voice-profile-${p.id}`}
                              onClick={() => {
                                setVoiceKind("profile");
                                setProfileId(String(p.id));
                              }}
                            >
                              {p.label}
                              {isBound ? "(人物绑定)" : ""}
                              {!voiceProfileSupportsTuning(p) && (
                                <LegacyVoiceBadge className="ml-1" />
                              )}
                            </OptionChip>
                          );
                        })}
                      </OptionChipGroup>
                    ) : (
                      !voiceProfilesQuery.isLoading && (
                        <p className="text-2xs text-muted-foreground">
                          还没有声纹,去人物库或声音库克隆一条
                        </p>
                      )
                    )}
                    {/* ★现网真实事故的直接解药:人物绑定哪条声纹现在有名有姓地摆在这儿 ——
                        此前(人物「阿杰」绑的声纹 label 叫「彭姐」)页面完全看不出绑的是
                        哪条,静默错配。 */}
                    {boundVoiceProfileId != null && (
                      <p
                        className="text-2xs text-muted-foreground"
                        data-testid="real-voice-bound-hint"
                      >
                        「{pick?.character.name}」绑定的声纹:
                        {boundVoiceProfile?.label ?? `#${boundVoiceProfileId}`}
                      </p>
                    )}
                    {/* ★错配防呆:选中声纹与人物绑定声纹不是同一条时轻提示,不拦提交。 */}
                    {voiceProfileMismatch && (
                      <p
                        className="text-2xs text-amber-600 dark:text-amber-400"
                        data-testid="real-voice-mismatch-hint"
                      >
                        当前选的声纹和「{pick?.character.name}」绑定的「
                        {boundVoiceProfile?.label ?? `#${boundVoiceProfileId}`}
                        」不是同一条,确认这是你想要的
                      </p>
                    )}
                  </div>

                  <div className="space-y-1.5">
                    <Label className="text-xs">预置音色</Label>
                    <OptionChipGroup label="预置音色">
                      {VOICE_OPTIONS.map((v) => (
                        <OptionChip
                          key={v.value}
                          radio
                          active={
                            voiceKind === "preset" &&
                            (form.voiceTone || NEUTRAL_VOICE_TONE) === v.value
                          }
                          tabIndex={
                            voiceKind === "preset" &&
                            (form.voiceTone || NEUTRAL_VOICE_TONE) === v.value
                              ? 0
                              : -1
                          }
                          onClick={() => {
                            setVoiceKind("preset");
                            setForm((s) => ({ ...s, voiceTone: v.value }));
                          }}
                        >
                          {v.label}
                        </OptionChip>
                      ))}
                    </OptionChipGroup>
                  </div>

                  {/* ── 语言 / 方言 / 演绎(P0.6 0915 车 I):仅「我的声纹」真实生效 ——
                      预置音色是旧引擎不认这三个参数,选中时整段禁用置灰 + 顶部说明
                      (抄数字人页「不整体消失」的处理方式:能力常驻可见)。 */}
                  <div className="space-y-2">
                    {!voiceTuningUnlocked && (
                      <p
                        className="text-2xs leading-relaxed text-muted-foreground"
                        data-testid="real-voice-v2-locked"
                        data-lock-reason={legacyProfileSelected ? "legacy-profile" : "preset"}
                      >
                        {legacyProfileSelected ? LEGACY_PROFILE_LOCK_TEXT : PRESET_VOICE_LOCK_TEXT}
                      </p>
                    )}
                    <div
                      data-testid="real-voice-v2"
                      aria-disabled={!voiceTuningUnlocked}
                      className={cn(
                        "space-y-3",
                        !voiceTuningUnlocked && "pointer-events-none select-none opacity-50"
                      )}
                    >
                      <div className="space-y-1.5">
                        <Label htmlFor="real-voice-language" className="text-xs">
                          语言
                        </Label>
                        <Select
                          value={voiceLanguage}
                          onValueChange={onChangeVoiceLanguage}
                          disabled={!voiceTuningUnlocked}
                        >
                          <SelectTrigger
                            id="real-voice-language"
                            data-testid="real-voice-language"
                            className="text-sm"
                          >
                            <SelectValue />
                          </SelectTrigger>
                          <SelectContent>
                            {DH_VOICE_LANGUAGES.map((l) => (
                              <SelectItem key={l.value} value={l.value}>
                                {l.label}
                              </SelectItem>
                            ))}
                          </SelectContent>
                        </Select>
                      </div>
                      {/* 方言:中文专属(契约「仅 zh 可非空」;换语言时 onChangeVoiceLanguage
                          已顺手清方言,这里只按语言闸渲染)。 */}
                      {voiceLanguage === "zh" && (
                        <div className="space-y-1.5">
                          <Label htmlFor="real-voice-dialect" className="text-xs">
                            口音 / 方言
                          </Label>
                          <Select
                            value={voiceDialect ?? "__original__"}
                            onValueChange={(v) => setVoiceDialect(v === "__original__" ? null : v)}
                            disabled={!voiceTuningUnlocked}
                          >
                            <SelectTrigger
                              id="real-voice-dialect"
                              data-testid="real-voice-dialect"
                              className="text-sm"
                            >
                              <SelectValue />
                            </SelectTrigger>
                            <SelectContent>
                              <SelectItem value="__original__">跟随原声</SelectItem>
                              {DH_VOICE_DIALECTS.map((d) => (
                                <SelectItem key={d.value} value={d.value}>
                                  {d.label}
                                </SelectItem>
                              ))}
                            </SelectContent>
                          </Select>
                        </div>
                      )}
                      <div className="space-y-1.5">
                        <Label className="text-xs">演绎方式</Label>
                        <OptionChipGroup label="演绎方式">
                          {DH_VOICE_STYLES.map((s) => {
                            const active = voiceStyle === s.value;
                            return (
                              <OptionChip
                                key={s.value}
                                radio
                                active={active}
                                tabIndex={active ? 0 : -1}
                                disabled={!voiceTuningUnlocked}
                                title={s.desc}
                                onClick={() => setVoiceStyle(s.value)}
                              >
                                {s.label}
                              </OptionChip>
                            );
                          })}
                        </OptionChipGroup>
                        <p
                          className="text-2xs text-muted-foreground"
                          data-testid="real-voice-style-desc"
                        >
                          {(() => {
                            const cur = DH_VOICE_STYLES.find((s) => s.value === voiceStyle);
                            return cur ? `${cur.label}:${cur.desc}。` : "";
                          })()}
                          {VOICE_STYLE_TRADEOFF_TEXT}
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* ── 语速(既有字段 voiceSpeechRate,合法域 0.9~1.3,绝不可改名)──────
                      两条路(声纹/预置)都吃,不因预置音色而收起。离散档,不做连续滑杆
                      (0908 老板实测「设 1.2 没变快」的教训)。 */}
                  <div className="space-y-1.5" data-testid="real-speech-rate">
                    <div className="flex items-center justify-between">
                      <Label className="text-xs">语速</Label>
                      <span className="text-xs tabular-nums text-muted-foreground">
                        {form.voiceSpeechRate ?? DEFAULT_VOICE_SPEECH_RATE}x
                      </span>
                    </div>
                    <OptionChipGroup label="语速">
                      {REAL_SPEECH_RATE_STEPS.map((s) => {
                        const active =
                          nearestRealSpeechStep(
                            form.voiceSpeechRate ?? DEFAULT_VOICE_SPEECH_RATE
                          ) === s.value;
                        return (
                          <OptionChip
                            key={s.value}
                            radio
                            active={active}
                            tabIndex={active ? 0 : -1}
                            data-testid={`real-speech-rate-${s.value}`}
                            onClick={() => setForm((s2) => ({ ...s2, voiceSpeechRate: s.value }))}
                          >
                            {s.label}
                          </OptionChip>
                        );
                      })}
                    </OptionChipGroup>
                  </div>

                  {/* ── 试听(P0.6 0915 车 I):调 previewVoice,按当前组合合成一小段。
                      两条路都可点:预置路给 form.voiceTone,声纹路要求先选中具体一条。 ─── */}
                  {(() => {
                    const previewable = voiceKind === "preset" || !!profileId;
                    const previewDesc =
                      voiceKind === "profile"
                        ? profileId
                          ? `${voiceProfiles.find((p) => String(p.id) === profileId)?.label ?? "我的声纹"} · ${
                              DH_VOICE_LANGUAGES.find((l) => l.value === voiceLanguage)?.label ??
                              voiceLanguage
                            }${voiceLanguage === "zh" ? ` · ${dialectLabelOf(voiceDialect)}` : ""} · ${voiceStyleLabelOf(voiceStyle)}`
                          : "先在上面选一条我的声纹"
                        : (VOICE_OPTIONS.find(
                            (v) => v.value === (form.voiceTone || NEUTRAL_VOICE_TONE)
                          )?.label ?? "预置音色");
                    return (
                      <div
                        data-testid="real-voice-preview"
                        aria-disabled={!previewable}
                        className={cn(
                          "flex flex-wrap items-center gap-3 rounded-md border border-primary/40 bg-primary/5 p-3",
                          !previewable && "pointer-events-none select-none opacity-50"
                        )}
                      >
                        <button
                          type="button"
                          data-testid="real-voice-preview-btn"
                          aria-label="试听这套声音"
                          disabled={previewingVoice || !previewable}
                          onClick={() => void previewVoiceCombo()}
                          className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary text-primary-foreground transition hover:bg-primary/90 disabled:opacity-70"
                        >
                          {previewingVoice ? (
                            <Loader2 className="h-4 w-4 animate-spin" />
                          ) : (
                            <Play className="ml-0.5 h-4 w-4" />
                          )}
                        </button>
                        <div className="min-w-0 flex-1">
                          <div className="text-sm font-medium">试听这套声音</div>
                          <div className="truncate text-2xs text-muted-foreground">
                            {previewDesc}
                          </div>
                        </div>
                        {voicePreviewUrl && (
                          // eslint-disable-next-line jsx-a11y/media-has-caption
                          <audio
                            onPlay={pauseOtherAudio}
                            src={voicePreviewUrl}
                            controls
                            autoPlay
                            data-testid="real-voice-preview-audio"
                            className="h-8 w-44 shrink-0 max-sm:w-full"
                          />
                        )}
                      </div>
                    );
                  })()}

                  <div className="text-2xs text-muted-foreground">口型为自然演绎,非逐字对口</div>
                </div>
              )}

              <div className="flex items-center justify-between border-t border-border/60 pt-3">
                <div className="text-sm font-medium">字幕</div>
                <Switch checked={subtitleOn} onCheckedChange={setSubtitleOn} />
              </div>

              {/* P0.6(0915 任务书车 V):keepSourceAudio 已接契约,开关放开(真实语义,
                  不再是「暂不接入实际出片,仅记录意向」那句占位话术)。 */}
              {mode === "swap" && KEEP_SOURCE_AUDIO_READY && (
                <div className="flex items-center justify-between border-t border-border/60 pt-3">
                  <div>
                    <div className="text-sm font-medium">保留参考视频原声</div>
                    <div className="text-2xs text-muted-foreground">
                      开启后保留参考视频里的原声/环境音,与口播、背景音乐混在一起
                    </div>
                  </div>
                  <Switch checked={keepSourceAudio} onCheckedChange={setKeepSourceAudio} />
                </div>
              )}

              <div className="space-y-1.5 border-t border-border/60 pt-3">
                <span className="text-xs text-muted-foreground">背景音乐</span>
                <VideoBgmPanel
                  bgms={bgms}
                  bgmTab={bgmTab}
                  setBgmTab={setBgmTab}
                  form={form}
                  setForm={setForm}
                  customBgmFile={customBgmFile}
                  customBgmUrl={customBgmUrl}
                  uploadingBgm={uploadingBgm}
                  onClearCustomBgm={() => {
                    setCustomBgmFile(null);
                    setCustomBgmUrl(null);
                  }}
                  onCustomBgmUpload={handleCustomBgmUpload}
                />
              </div>
            </CardContent>
          </Card>
        </aside>
      </div>

      {submitError && (
        <p
          data-testid="real-submit-error"
          className="rounded-md border border-destructive/40 bg-destructive/5 px-3 py-2 text-sm text-destructive"
        >
          {submitError}
        </p>
      )}

      {/* ── 底部 sticky 条(拍板点 B):摘要句/缺口提示 + 积分预估 + 出片 ───────── */}
      <div className="sticky bottom-0 z-10 flex flex-wrap items-center justify-between gap-3 rounded-lg border bg-card/95 px-4 py-3 shadow-[0_-4px_16px_rgba(0,0,0,0.12)] backdrop-blur supports-[backdrop-filter]:bg-card/85">
        {/* 1007:提交按钮旁再提醒一次会被截掉的口播(不拦提交)。 */}
        {voiceoverOn && (
          <VoiceoverCutSubmitNotice
            text={voiceoverText}
            durationSec={voiceoverDurationSec}
            className="w-full"
          />
        )}
        <div className="min-w-0 text-sm text-muted-foreground" data-testid="real-bottom-summary">
          {missingHint ? (
            <>
              还差:<span className="font-medium text-foreground">{missingHint}</span>
            </>
          ) : (
            <>
              出镜人 <span className="font-medium text-foreground">{pick!.character.name}</span>
              {" · "}
              {mode === "text" ? (
                <>
                  文案出片 · {form.durationSec}s · {form.ratio}
                </>
              ) : (
                <>
                  换我出镜 ·{" "}
                  {swapDurationSec != null
                    ? `${swapDurationSec}s 跟随参考视频`
                    : "时长跟随参考视频"}
                </>
              )}
              {" · 口播"}
              {voiceoverOn ? "开" : "关"}
              {" · 字幕"}
              {subtitleOn ? "开" : "关"}
            </>
          )}
        </div>
        <div className="flex items-center gap-4">
          <div className="text-sm text-muted-foreground">
            {estimatedCredits != null ? (
              <>
                预估 <span className="font-medium text-foreground">{estimatedCredits}</span> 积分
              </>
            ) : (
              "积分预估中…"
            )}
            {/* ★vin 族报价修正(0915 车 E):文案出片对挂了视频形象的人物,提交会带上 ta 的
                身份参考视频一起计量 —— 报价旁说清楚这笔用量从哪来,不是空涨价。换我出镜
                本身就是传视频进去,不需要这句(用户自己刚传完,不解释也懂)。 */}
            {mode === "text" && identityRefBillsAsVideoInput(identityRefMode) && (
              <span data-testid="real-vin-quote-hint" className="ml-1.5 text-2xs">
                (含身份视频参考的画面用量)
              </span>
            )}
          </div>
          <Button size="lg" disabled={!canSubmit || submitting} onClick={() => void onSubmit()}>
            {submitting ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                出片中…
              </>
            ) : (
              <>
                出片
                <ArrowRight className="ml-2 h-4 w-4" />
              </>
            )}
          </Button>
        </div>
      </div>
    </div>
  );
}

/** 区块眉标(拍板点 C):1/2/3 只标注自上而下的阅读顺序,无导航语义,不是步骤条。 */
function SectionHead({ num, title, hint }: { num: number; title: string; hint?: string }) {
  return (
    <div className="mb-2.5 flex items-baseline gap-2">
      <span className="rounded-full border border-primary/40 bg-primary/10 px-2 text-[11px] font-bold leading-5 text-primary">
        {num}
      </span>
      <span className="text-sm font-semibold">{title}</span>
      {hint && <span className="text-2xs text-muted-foreground">{hint}</span>}
    </div>
  );
}

/** 出镜人横向小卡(区块 1)—— 判据同 D4:selectable 可点,其余置灰 + 原因;选中亮主色环。 */
function RealPersonCard({
  c,
  onPick,
  resolving,
  selected,
}: {
  c: CharacterDto;
  onPick: () => void;
  resolving: boolean;
  selected: boolean;
}) {
  const state = realPersonPickState(c);
  const blocked = state !== "selectable";
  const hasPhoto = !!(c.primaryMaterialId || c.primaryUrl || c.primaryThumbUrl);
  return (
    <div
      data-testid={`real-char-card-${c.id}`}
      data-real-person-state={state}
      data-selected={selected || undefined}
      aria-disabled={blocked || undefined}
      className={cn(
        "flex w-[200px] shrink-0 items-center gap-3 border bg-card p-3 transition-shadow",
        CARD_WALL_RADIUS,
        blocked
          ? "cursor-not-allowed opacity-50"
          : selected
            ? "border-primary shadow-[0_0_0_1px_hsl(var(--primary))]"
            : "cursor-pointer hover:shadow-md",
        resolving && "opacity-60"
      )}
      {...(blocked || resolving ? {} : clickableCardProps(onPick))}
    >
      <div className="h-12 w-12 shrink-0 overflow-hidden rounded-full bg-muted">
        {/* 主素材可能是视频(只有视频的人物)—— 按 kind 分派,别拿 mp4 塞 <img>。 */}
        <CharacterThumb character={c} iconClassName="h-5 w-5" />
      </div>
      <div className="min-w-0 flex-1 space-y-1">
        <div className="flex items-center gap-1.5">
          <span className="truncate text-sm font-medium">{c.name}</span>
          {resolving && <Loader2 className="h-3 w-3 shrink-0 animate-spin text-muted-foreground" />}
        </div>
        <div className="flex flex-wrap items-center gap-1.5">
          {/* 素材角标(P0.6 挂账车 L,0915):「照片」看 primaryMaterialId 是否有 identity 物料;
              「视频」看后端下发的 hasVideoAvatar —— 服务端按 avatar_profile.character_id 显式
              挂接优先、principal 兜底次之算好这个布尔(与真人出镜视频身份解析同一份判据),
              console 只管展示,不再靠弱关联猜。两个角标可并存;hasVideoAvatar 缺席(老后端)
              按「没有」处理,不新展示视频角标。 */}
          {hasPhoto && (
            <Badge variant="outline" className="text-2xs">
              照片
            </Badge>
          )}
          {c.hasVideoAvatar === true && (
            <Badge variant="outline" className="text-2xs">
              视频
            </Badge>
          )}
          {!blocked ? (
            <Badge variant="secondary" className="text-2xs">
              已授权
            </Badge>
          ) : (
            <span
              data-testid={`real-char-blocked-${c.id}`}
              className="text-2xs text-muted-foreground"
            >
              {realPersonPickReason(state)}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
